import { render, staticRenderFns } from "./InsertProject.vue?vue&type=template&id=c9a1922c&scoped=true"
import script from "./InsertProject.vue?vue&type=script&lang=js"
export * from "./InsertProject.vue?vue&type=script&lang=js"
import style0 from "./InsertProject.vue?vue&type=style&index=0&id=c9a1922c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a1922c",
  null
  
)

export default component.exports